import React from 'react'
import { pathFromApi } from '../display-asset'
import NewWindowIcon from './new-window-icon'

const defaultMessage = 'Government Correspondance '

export const GovCorrespondenceDisplay = ({ link, body = defaultMessage }) => (
  // A PDF is on the other end of the link
  <a
    href={pathFromApi(link)}
    target="_blank"
    rel="noopener noreferrer"
    title="Link will open in a new window">
    {body}
    <NewWindowIcon />
  </a>
)



// WEBPACK FOOTER //
// ./src/ui/gov-messages/views/correspondence.jsx